module.exports = __webpack_public_path__ + "img/laji.bc891df0.png";